import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {baseUrl, tokenKey} from "./authProvider";
import "./ApproveButton.scss";
import DefaultNoImage from "./assets/default-attachment.png";
import JoditEditor from "jodit-react";
import {toast} from "react-toastify";

let struct = {
    basePath: '',
    resource: '',
    fields: {},
    editors: {},
    images: {},
    files: {},
    checkboxes: {},
    selections: {},
    selectionFields: [],
    gallery: {},
    dateTime: {}
}

class BaseForm extends Component {

    state = {
        id: 0,
        loading: false
    };

    componentDidMount() {
        const {
            record,
            basePath,
            resource,
            fields,
            images,
            files,
            selections,
            editors,
            checkboxes,
            gallery,
            dateTime
        } = this.props;
        struct = {
            basePath,
            resource: resource.replaceAll('-', ' '),
            fields,
            images,
            files,
            selections,
            editors,
            checkboxes,
            gallery,
            dateTime
        }
        if (record.id) {
            this.setState({id: record.id});
            for (const key of Object.keys(fields)) {
                this.setState({[key]: record[key]});
            }
            for (const item of [images, files, gallery]) {
                if (item) {
                    for (const key of Object.keys(item)) {
                        this.setState({[`data-${key}`]: record[key]});
                    }
                }
            }
            for (const item of [selections, editors, checkboxes, dateTime]) {
                if (item) {
                    for (const key of Object.keys(item)) {
                        this.setState({[key]: record[key]});
                    }
                }
            }

        } else {
            this.setState({...fields})
            if (images) this.setState({...images})
            if (selections) this.setState({...selections})
            if (editors) this.setState({...editors})
            if (checkboxes) this.setState({...checkboxes})
            if (dateTime) this.setState({...dateTime})
        }
        if (files) this.setState({...files})
        const selectField = []
        if (selections) {
            for (const key of Object.keys(selections)) {
                selectField.push({key: key, route: selections[key]});
            }
        }
        this.setState({selectionFields: selectField});

    }

    generateHeaders = () => {
        const token = localStorage.getItem(tokenKey);
        return {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        };
    };

    submit = () => {
        let form_data = new FormData();
        let checkboxes = []
        let gallery = []
        if (struct.checkboxes)
            checkboxes = Object.keys(struct.checkboxes)
        if (struct.gallery)
            gallery = Object.keys(struct.gallery)

        for (const key of Object.keys(this.state)) {
            if (key === "id" || key === 'selectionFields' || key.includes('data-')) continue;
            if (checkboxes.includes(key))
                form_data.append(key, +this.state[key]);
            else if (gallery.includes(key) && this.state[key] && this.state[key].length > 0) {
                form_data.append(`${key}_length`, this.state[key].length);
                for (let i = 0; i < this.state[key].length; i++) {
                    form_data.append(`${key}_${i}`, this.state[key][i]);
                }
            } else
                form_data.append(key, this.state[key]);

        }
        this.setState({loading: true});
        const t = this
        if (this.state.id) {
            axios.post(`${baseUrl}${struct.basePath}/update/${this.state.id}`, form_data, {
                headers: this.generateHeaders()
            }).then(response => {
                t.setState({loading: false});
                const {statusCode, errors} = response.data;
                if (statusCode !== 200) {
                    alert(errors.join(" "));
                    return;
                }
                toast.success(`Edit ${struct.resource} successfully`)
                // window.location.reload();
            }).catch(error => {
                t.setState({loading: false});
                console.log(error);
                toast.error("Something went wrong!")
            })
            return;
        }
        axios.post(`${baseUrl}${struct.basePath}`, form_data, {
            headers: this.generateHeaders()
        }).then(response => {
            t.setState({loading: false});
            const {statusCode, errors} = response.data;
            if (statusCode !== 200) {
                alert(errors.join(" "));
                return;
            }
            toast.success(`Create ${struct.resource} successfully`)
            window.location.href = window.location.href.replace("create", response.data.data.id);
        }).catch(error => {
            t.setState({loading: false});
            console.log(error);
            toast.error("Something went wrong!")
        })
    };

    delete = () => {
        if (!window.confirm(`Do you want to delete this ${struct.resource}?`)) return;

        axios.delete(`${baseUrl}${struct.basePath}/${this.state.id}`, {
            headers: this.generateHeaders()
        }).then(response => {
            toast.success(`Delete ${struct.resource} success!`);
            window.location.href = window.location.href.replace(this.state.id, "");
        }).catch(error => {
            console.log(error);
            toast.error("Something went wrong!")
        })
    }


    handleFileChange = (e, type) => {
        const file = e.target.files[0]
        let preview = null
        if (file) {
            this.setState({[e.target.name]: file})
            if (type === 'photo') {
                preview = URL.createObjectURL(e.target.files[0]);
                this.setState({
                    [`data-${e.target.name}`]: preview,
                });
            } else
                this.setState({
                    [`data-${e.target.name}`]: file.name,
                })
        } else
            this.setState({
                [e.target.name]: null,
                [`data-${e.target.name}`]: null,
            });
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    inputText(name) {
        return <div className='mt-3'>
            <div><b>{name.replaceAll('_', ' ').toUpperCase()}</b>:</div>
            <input
                type='text'
                className="form-control"
                onChange={this.handleChange(name)}
                value={this.state[name]}
            />
        </div>
    }

    inputDateTime(name) {
        return <div className='mt-3'>
            <div><b>{name.replaceAll('_', ' ').toUpperCase()}</b>:</div>
            <input
                type='datetime-local'
                className="form-control"
                onChange={this.handleChange(name)}
                value={this.state[name]}
            />
        </div>
    }

    inputEditor(name) {
        return <div className='mt-3'>
            <div><b>{name.replaceAll('_', ' ').toUpperCase()}</b>:</div>
            <JoditEditor
                value={this.state[name]}
                tabIndex={1} // tabIndex of textarea
                onBlur={newContent => this.setState({[name]: newContent})} // preferred to use only this option to update the content for performance reasons
                className='form-control'
            />
        </div>
    }

    inputCheckbox(name) {
        return <div className='mt-3'>
            <input checked={this.state[name]} type="checkbox" value="1" id={name}
                   onChange={e => this.setState({[name]: e.target.checked})}/>
            <label className="control-label" htmlFor={name}
                   style={{marginLeft: "15px"}}><b>{name.replaceAll('_', ' ').toUpperCase()}?</b></label>
        </div>
    }

    inputFile(name, type = 'photo') {
        return <div className='mt-3'>
            <div>
                <div><b>{name.replaceAll('_', ' ').toUpperCase()}</b>:</div>
                <input
                    type="file"
                    name={name}
                    onChange={e => this.handleFileChange(e, type)}
                />
            </div>
            {type === 'photo' ?
                <img
                    className="Photo"
                    alt="attachment"
                    src={this.state[`data-${name}`] ? this.state[`data-${name}`] : DefaultNoImage}
                /> : ((this.state.id) ? (
                    <div>
                        <div>Uploaded file: <a href={this.state[`data-${name}`]}
                                               target={"_blank"}>{this.state[`data-${name}`]}</a></div>
                    </div>
                ) : (
                    <React.Fragment/>
                ))}
        </div>
    }

    inputSelect(name, route) {
        this.getCategories(name, route)
        return <div className='mt-3'>
            <div><b>{name.replaceAll('_', ' ').toUpperCase()}</b>:</div>
            <select
                className="form-control"
                onChange={this.handleChange(name)}
                value={this.state[name]}
            >
                <option value="0">Select</option>
                {this.state[`data-${name}`] ? this.state[`data-${name}`].map((item, index) => (
                    <option key={index} value={item.id} selected={item.id === this.state[name]}>{item.name}</option>
                )) : ""}
            </select>
        </div>
    }

    getCategories(name, route) {
        if (this.state[`data-${name}`] && this.state[`data-${name}`].length > 0) return
        const t = this
        axios.get(`${baseUrl}/${route}`, {
            headers: this.generateHeaders()
        }).then(function (res) {
            t.setState({
                [`data-${name}`]: res.data.data
            })
        })
    }

    handleGalleryChange = (e) => {
        this.setState({
            [`${e.target.name}`]: e.target.files,
        });
    };

    getInputGallery(name) {
        return <div className='mt-3'>
            <div>
                <div><b>{name.replaceAll('_', ' ').toUpperCase()} (can upload multiple)</b>:</div>
                <input
                    type="file"
                    name={name}
                    onChange={e => this.handleGalleryChange(e)}
                    multiple={true}
                    accept="image/*"
                />
            </div>
            {(this.state.id) ? (
                <div>
                    <div>Uploaded file: </div>
                    <ul>
                        {this.state[`data-${name}`] ? this.state[`data-${name}`].map((item, index) => (
                            <li key={index}><a href={item} target={"_blank"}>{item}</a></li>
                        )) : <React.Fragment/>}
                    </ul>
                </div>
            ) : (
                <React.Fragment/>
            )}
        </div>
    }

    getInput() {
        const render = []
        for (const key of Object.keys(struct.fields)) {
            render.push(this.inputText(key))
        }
        if (struct.editors) {
            for (const key of Object.keys(struct.editors)) {
                render.push(this.inputEditor(key))
            }
        }
        if (struct.dateTime) {
            for (const key of Object.keys(struct.dateTime)) {
                render.push(this.inputDateTime(key))
            }
        }
        if (struct.checkboxes) {
            for (const key of Object.keys(struct.checkboxes)) {
                render.push(this.inputCheckbox(key))
            }
        }
        if (this.state.selectionFields && this.state.selectionFields.length > 0) {
            for (const selectionField of this.state.selectionFields) {
                render.push(this.inputSelect(selectionField.key, selectionField.route));
            }
        }
        if (struct.images) {
            for (const key of Object.keys(struct.images)) {
                render.push(this.inputFile(key, 'photo'))
            }
        }
        if (struct.files) {
            for (const key of Object.keys(struct.files)) {
                render.push(this.inputFile(key, 'file'))
            }
        }
        if (struct.gallery) {
            for (const key of Object.keys(struct.gallery)) {
                render.push(this.getInputGallery(key))
            }
        }

        return render
    }

    render() {
        return (
            <div className="form-group">
                <h3>{this.state.id ? `Update ${struct.resource} ${this.state.name}` : `Create ${struct.resource}`}</h3>
                <Fragment>
                    {this.getInput()}
                    <div className="action-button">
                        <input
                            type="button"
                            className="accept-button"
                            onClick={this.submit}
                            value="Submit"
                            disabled={this.state.loading}
                        />
                    </div>
                    {(this.state.id) ? (
                        <div className="action-button">
                            <input
                                type="button"
                                className="accept-button"
                                onClick={this.delete}
                                value="Delete"
                                disabled={this.state.loading}
                            />
                        </div>
                    ) : <React.Fragment/>}
                </Fragment>
            </div>
        );
    }
}

export default connect(
    null,
    {}
)(BaseForm);